import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'query-view',
    templateUrl: './query-view.component.html',
    styleUrls: ['./query-view.component.scss'],
    standalone: false
})
export class QueryViewComponent implements OnInit {

  constructor() { }
  joinSql:string;
  @Input() queryForm:UntypedFormGroup;
  @Input() showPackSize=true;
  @Input() nuInt= 0;
  showJoinSql = true;
  queryData = null;
  ngOnInit(): void {

      if( this.nuInt == 1 ){
        this.showPackSize = true;
      }else{
        this.showPackSize = false;
      }

      if ( this.queryForm.get('EXPRESSION').value != null ){
        this.queryData = this.queryForm.get('EXPRESSION').value;
      }

      if ( this.nuInt == 7 ){
          this.showJoinSql = false;
      }else{
        this.showJoinSql = true;
      }
      
  }

  set query(value){
      this.queryData = value;
  }

  get query(){
    return this.queryData; //this.queryForm.get('EXPRESSION').value;
  }

  onToggleChange(column){ 
    if ( column=="JOINSQL"){
      if ( this.joinSql ){
        this.queryForm.get(column).setValue("S");
      }else{
        this.queryForm.get(column).setValue("N");
      }
      
    }
  }

  onQueryChange(evento){
    this.queryForm.get("EXPRESSION").setValue(evento);
  }


}
